import React from 'react';
import PropTypes from 'prop-types';
import { MultiStepTracker, Step } from '@americanexpress/dls-react';
import { getIcon } from './Icons';

const MultiTracker = ({ trackerOptions, stepValue, cssProperties }) => (
  <div className={cssProperties?.style || 'col-md-12 margin-3-tb'}>
    <MultiStepTracker currentStep={stepValue} label="Application Process">
      {trackerOptions.map((i) => (
        <Step
          label={i.step}
          key={i.step}
          icon={i.iconName !== undefined ? getIcon(i.iconName) : ''}
          gatewayIcon={getIcon(i.gatewayIcon)}
          gatewayLabel={i?.gatewayLabel || `${i.step} Gateway`}
          gatewayCompleteLabel={i?.gatewayCompleteLabel || `${i.step} Gateway Completed`}
        />
      ))}
    </MultiStepTracker>
  </div>
);

MultiTracker.propTypes = {
  trackerOptions: PropTypes.string,
  stepValue: PropTypes.string,
  cssProperties: PropTypes.objectOf(PropTypes.shape),
};

export default MultiTracker;
